import { uploadImageToS3 } from '@/utils/imageUtils';

(function () {
    'use strict';
    'ngInject';
    angular.module('app.ctrls').controller('CategoryDialogCtrl', categoryDialogCtrl);

    function categoryDialogCtrl(
        $scope,
        $mdDialog,
        $timeout,
        LibrariesAPIService,
        ImageAPIService,
        VectorUtilService,
        blockUI,
        library,
        category,
        thumbnailOnly
    ) {
        $scope.libraryType = library.Type;
        $scope.category = category;
        $scope.thumbnailOnly = thumbnailOnly;
        $scope.categoryName = 'My category';
        $scope.errorMessage = '';
        $scope.filePath = '';
        $scope.thumbnailPath = '';
        $scope.createBtnDisabled = false;
        $scope.hasThumbnail = false;

        if (category != null) {
            $scope.categoryName = category.Name;
            if (library.Type === 2 || library.Type === 3) {
                $scope.filePath = category.Path;
                $scope.thumbnailPath = category.ThumbnailPath;
            }
        }

        if (library.Type === 2 || library.Type === 3) {
            $scope.createBtnDisabled = !$scope.categoryName && !$scope.filePath;
        }

        $scope.create = async function () {
            if (!$scope.categoryName || ((library.Type === 2 || library.Type === 3) && !$scope.filePath)) {
                $scope.hasThumbnail = true;
                return;
            }

            const currentCategory = {
                Name: $scope.categoryName
            };

            if (library.Type === 2 || library.Type === 3) {
                currentCategory.Path = $scope.filePath;
                currentCategory.ThumbnailPath = $scope.thumbnailPath;
            }

            // If category is not null we are in edit mode, update the category instead of creating it
            if (category === null) {
                blockUI.start('Creating category');
                LibrariesAPIService.addCategory(library.LibraryId, currentCategory)
                    .then(function () {
                        blockUI.reset();
                        $mdDialog.hide();
                    })
                    .catch(function (error) {
                        window.rumReportError(error);
                        blockUI.reset();
                        $scope.errorMessage = 'Error creating category!';
                    });
            } else {
                // Update category
                blockUI.start('Updating category');
                LibrariesAPIService.updateCategory(library.LibraryId, category.CategoryId, currentCategory)
                    .then(function () {
                        // Category updated!
                        blockUI.reset();
                        $mdDialog.hide();
                    })
                    .catch(function (error) {
                        blockUI.reset();
                        window.rumReportError(error);
                        $scope.errorMessage = 'Error updating category!';
                    });
            }
        };

        $scope.uploadImage = async function (event) {
            const files = event.target.files;
            if (files && files[0]) {
                try {
                    $scope.errorMessage = '';
                    $scope.hasThumbnail = false;
                    // Upload image to S3 and generate a thumbnail from it
                    blockUI.start('Uploading Image');
                    const response = await uploadImageToS3('library-categories', files[0], function (progress) {
                        blockUI.message(`Uploading Image ${parseInt(progress)}%`);
                    });
                    const thumbResponse = await ImageAPIService.generateImageThumbnail(
                        response.Name,
                        'library-categories'
                    );
                    console.log('Success on image upload!');
                    $scope.filePath = response.Path;
                    $scope.thumbnailPath = thumbResponse.Path;

                    blockUI.stop();
                    $timeout(() => $scope.$apply());
                } catch (error) {
                    $scope.hasThumbnail = true;
                    window.rumReportError(error);
                    console.error(error);
                    $scope.errorMessage = 'Error uploading image';
                    blockUI.stop();
                    $timeout(() => $scope.$apply());
                }
            }
            $scope.createBtnDisabled = !$scope.categoryName && !$scope.filePath;
        };

        $scope.uploadEPS = async function (event) {
            const files = event.target.files;
            if (files && files[0]) {
                try {
                    // Upload the EPS file
                    $scope.uploadingVectorEPS = true;
                    $scope.vectorEPSUploadPercent = 0;
                    blockUI.start('Uploading EPS');

                    const response = await VectorUtilService.uploadVectorToS3(
                        files[0],
                        'vector',
                        false,
                        true,
                        (type, progress) => {
                            if (type === 'upload') {
                                blockUI.message(`Uploading EPS: ${parseInt(progress)}%`);
                                $timeout(() => $scope.$apply());
                            } else {
                                blockUI.message(`Processing`);
                            }
                        }
                    );

                    console.log('Success on EPS upload!');
                    $scope.errorMessage = '';
                    $scope.filePath = response.SVG;
                    $scope.thumbnailPath = response.ThumbnailPath;

                    blockUI.stop();
                    $scope.uploadingVectorEPS = false;
                    $timeout(() => $scope.$apply());
                } catch (error) {
                    console.error(error);
                    blockUI.stop();
                    $scope.uploadingVectorEPS = false;
                    $scope.errorMessage = error;
                    $timeout(() => $scope.$apply());
                }
            }
            $scope.createBtnDisabled = !$scope.categoryName && !$scope.filePath;
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    }
})();
